import { useNavigate, useParams } from "react-router-dom";
import { useMe } from "../../hooks/useMe";
import { useAgentAlerts } from "../../hooks/personaQueries";

const ALERT_PILL: Record<string, string> = {
  expiring: "amber",
  degraded: "red",
  gap: "gray",
};

export function OwnerHome() {
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const { data: me } = useMe();
  const navigate = useNavigate();
  const { data: alerts, isLoading } = useAgentAlerts(workspaceId);
  const ws = me?.memberships.find((m) => m.workspaceId === workspaceId);
  const summary = alerts?.summary;
  const items = alerts?.alerts ?? [];

  return (
    <div className="main-inner" data-testid="owner-home">
      <div className="greet-row">
        <span className="greet">Good afternoon, {firstName(me?.user.displayName)}.</span>
        <span className="greet-date">Workspace · {ws?.workspaceName ?? "—"}</span>
      </div>
      <div className="subgreet">
        <div className="section-eyebrow">WORKSPACE OVERVIEW</div>
        <div className="lede">
          {summary ? (
            <>
              <b>{summary.healthy} healthy</b> · {summary.degraded} degraded ·{" "}
              {summary.expiring} expiring credentials.
            </>
          ) : (
            "Workspace summary will appear here as agents are bound."
          )}
        </div>
      </div>

      <div className="section-h">
        <span className="ttl">AGENT FLEET · NEEDS ATTENTION</span>
        <span className="meta">{items.length} items</span>
        <span style={{ flex: 1 }} />
        <a
          onClick={() => navigate(`/workspaces/${workspaceId}/agents`)}
          style={{ fontSize: 12, color: "var(--accent)", cursor: "pointer" }}
        >
          Open Agents →
        </a>
      </div>
      {isLoading ? (
        <Skeleton />
      ) : items.length === 0 ? (
        <EmptyState message="All agents healthy. Nothing needs your attention right now." />
      ) : (
        <div className="op-esc">
          {items.map((a) => (
            <div key={a.id} className="op-esc-row system">
              <div className="op-esc-l">
                <div className="op-esc-f">
                  <span className={`pill ${ALERT_PILL[a.kind] ?? "gray"}`} style={{ marginRight: 8 }}>
                    {a.kind}
                  </span>
                  {a.agent}
                </div>
                <div className="op-esc-t">{a.text}</div>
              </div>
              <div className="op-esc-r">
                <button type="button" className="btn primary">
                  {a.action}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function firstName(displayName?: string): string {
  if (!displayName) return "there";
  return displayName.split(/\s+/)[0] ?? displayName;
}

function Skeleton() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {[0, 1, 2].map((i) => (
        <div
          key={i}
          style={{
            height: 56,
            borderRadius: 8,
            background: "var(--bg-soft)",
            opacity: 0.6,
          }}
        />
      ))}
    </div>
  );
}

function EmptyState({ message }: { message: string }) {
  return (
    <div
      style={{
        padding: 24,
        textAlign: "center",
        color: "var(--text-3)",
        border: "1px dashed var(--border)",
        borderRadius: 8,
        fontSize: 13,
      }}
    >
      {message}
    </div>
  );
}
